
<template>
<!-- vheight -->
  <div class="vheight InformationCompany">
    <div
      class="header-seacher"
      v-resize="redraw"
      :inline="true"
      style="border-bottom: 0px dotted #797979;"
    ></div>

    <div
      class="container-boot"
      :style="{height:'calc(100%)'}"
      style="padding-right: 10px;padding-left: 10px;"
    >
      <el-tabs
        style="margin-top: 10px;"
        type="border-card"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="基本信息" name="first"></el-tab-pane>
        <el-tab-pane label="良好信息" name="second"></el-tab-pane>
        <el-tab-pane label="不良信息" name="third"></el-tab-pane>
      </el-tabs>
      <div class="search">
        <el-input class="ub-f1" v-model="keyWord" placeholder="请输入">
        </el-input>
        <el-button type="primary" >查询</el-button>
      </div>
      <!-- first show -->
      <div v-show="activeName === 'first'" class="grid">
        <el-table
          ref="multipleTable"
          :data="tableData"
           @cell-click='cellClick'
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="企业名称"
            prop="OrgName"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column label="满意度得分" 
          prop="EvaluateScore" 
          header-align="center" 
          align="center"
           width="150"
          ></el-table-column>
          <el-table-column
            label="满意度排名"
            prop="EvaluateRank"
            show-overflow-tooltip
            header-align="center"
            align="center"
             width="150"
          >
            <template slot-scope="scope">{{scope.row.EvaluateRank?scope.row.EvaluateRank:'/'}}</template>
          </el-table-column>

          <el-table-column
            label="在管面积㎡"
            width="150"
            prop="RealtyBuildTotalArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{Number(scope.row.RealtyBuildTotalArea).toFixed(2)}}</template>
          </el-table-column>
          <el-table-column
            label="共有资金账户"
            width="150"
            prop="RegComAccEaAreaCount"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="信息公开率(%)"
            label-class-name
            width="150"
            show-overflow-tooltip

            header-align="center"
            align="center"
          >
            <template
              slot-scope="scope"
            >{{scope.row.PublicInfoDoneCount,scope.row.PublicInfoShouldCount|getProbability}}</template>
          </el-table-column>
          <el-table-column
            label-class-name
            label="通知公告响应率(%)"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template
              slot-scope="scope"
            >{{scope.row.ViewedNoticeCount,scope.row.ReceiveNoticeTotalCount|getProbability}}</template>
          </el-table-column>
          <el-table-column
            label-class-name
            label="安全检查情况(%)"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template
              slot-scope="scope"
            >{{scope.row.SecuritycheckQualifieCount,scope.row.SecuritycheckTotalCount|getProbability}}</template>
          </el-table-column>
          <el-table-column
            label-class-name
            label="反馈率(%)"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{`${(Number(scope.row.EvaResRate)*100).toFixed(2)}`}}</template>
          </el-table-column>
          <el-table-column
            label-class-name
            label="统计填报情况"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{scope.row.ReportFillCount}}</template>
          </el-table-column>
          <el-table-column
            label-class-name
            label="全国在管面积㎡"
            width="150"
            prop="FloorArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{Number(scope.row.TotalArea).toFixed(2)}}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- second show -->
      <div v-show="activeName === 'second'" class="grid">
        <el-table
          ref="multipleTable"
          :data="tableGoodData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            label="企业名称"
            prop="orgName"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="绿色物业"
            width="150"
            prop="green"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="幸福小区"
            prop="Address"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{scope.row.happy}}</template>
          </el-table-column>
          <el-table-column
            label="绿色物业星级评价"
            width="180"
            prop="star"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="绿色物业示范项目"
            width="180"
            prop="model"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="连续六个月排名前十"
            width="200"
            prop="model"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{scope.row.top10}}</template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'third'" class="grid">
        <el-table
          ref="multipleTable"
          :data="tableBadData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column  
          align="center"
          prop="orgName"
           label="企业名称" >
           </el-table-column>
          <el-table-column
            prop="rectification"
            label-class-name
            label="责令整改"
            align="center"
            width="300"
          ></el-table-column>
          <el-table-column prop="punish" label-class-name label="行政处罚" align="center" width="300"></el-table-column>
          <el-table-column
            prop="arbitration"
            label-class-name
            label="法院判决"
            align="center"
            width="300"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer">
      <div class="page">
        <ps-page :page="page" @getData="getDetail(activeName)"></ps-page>
      </div>
    </div>
    <!-- <div class="PublicInformationDetail-footer">
      <ps-close></ps-close>
    </div>-->
  </div>
</template>
<script>
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
export default {
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      activeName: 'first', 
      tableData:[],
      tableGoodData:[],
      tableBadData:[],
      realtyMgekeyWord:'',
      page: new Page(),
      orgCode: ''
    }
  },
  computed: { ...mapState(['token', 'userInfo']) },
  created() {
    this.CreditInformationController = new CreditInformationController();
  },
  mounted() {
    //this.orgCode = this.$route.query.orgCode;
     this.getDetailData('first');
  },
  filters: {
        getProbability(num1,num2){
            if(num1==0||num2==0){
                return 0;
            }else{
                return (parseFloat(num1)/parseFloat(num2)*100).toFixed(2);
            }
        },
    }, 
  methods: {
    cellClick(){
      this.$router.push({
        path: 'PropInformation',
        query: { OrgCode: "2"}
      })
    },
    search(){},
    handleClick(tab, event) {
      if (tab.name === 'first') this.getDetailData(tab.name);
      if (tab.name === 'second') this.getDetailData(tab.name);
      if (tab.name === 'third') this.getDetailData(tab.name);
    },

    showPara() {},
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    getDetailData(activename) { 
      if (activename === 'first') {
        this.CreditInformationController.GetBasicInformationList( 
          this.realtyMgekeyWord,
         (this.page.currentPage - 1) * this.page.currtNum,
         this.page.currtNum
        )
          .then(res => { 
            if (res && res._Items) {
              this.tableData =res._Items; 
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error
            });
          });
      } else {
        //activename second 良好传值1，其他传0
        this.CreditInformationController.GetBehaviorList( 
          this.realtyMgekeyWord,
          activename=='second'?1:0,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then(res => {
            if (res && res._item) {
              if(activename==='second'){
                 this.tableGoodData=res._item;
              }else{
                this.tableBadData=res._item;
              } 
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error
            });
          });
      }
    }
  }
}
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.InformationCompany {
  .el-tabs__content {
    padding: 0px;
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.InformationCompany {
  // height: 100%;
  .search {
      width: 50%;
      display: flex;
      padding: 15px 0;
  }
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.InformationCompany {
  width: 100%;
  box-sizing: border-box;
  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 30px);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
  .page{
     z-index: 100;
  }
}
</style>